/* eslint-disable max-len */
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Image, Typography } from 'tfc-components';

import Container from '../Container';

import logo from 'assets/images/logo.png';
import Icon, { IconName } from 'components/atoms/Icon';

interface ISocial {
  name: IconName;
  link?: string;
  id: number;
}
// data social
const dataSocial: ISocial[] = [
  { name: 'facebook', link: 'https://www.facebook.com/evollabs/', id: 1 },
  { name: 'linkedIn', link: ' https://www.linkedin.com/company/evol-labs/', id: 2 },
  // { name: 'zalo', link: '', id: 3 },
  // { name: 'youtube', link: '', id: 4 },
];
const Footer: React.FC = () => (
  <footer className="o-footer">
    <Container>
      <div className="o-footer_logo">
        <Image imgSrc={logo} alt="EVOL Field" ratio={186 / 41} />
      </div>

      <div className="o-footer_description">
        <Typography.Text fontweight="400">
          Evol Labs combine speed, user insight, and cutting-edge AI to solve real-world problems
        </Typography.Text>
      </div>
      <div className="o-footer_nav">
        <Container>
          <NavLink to="/about-us" className="o-footer_nav_item">
            About EVOL LABS
          </NavLink>
          <NavLink to="/products" className="o-footer_nav_item">
            Our Services
          </NavLink>
          <a target="_blank" href="https://www.linkedin.com/company/evol-labs/" className="o-footer_nav_item" rel="noreferrer">
            Careers
          </a>
        </Container>
      </div>

      <div className="o-footer_social">
        {dataSocial.map((item) => (
          <a href={item.link} target="_blank" key={item.id} className="o-footer_social_item" rel="noreferrer">
            <Icon iconName={item.name} size="18" />
          </a>
        ))}
      </div>

      <Typography.Text extendClasses="o-footer_copyright">© 2025 EVOL LABS. All rights reserved.</Typography.Text>
    </Container>
  </footer>
);

export default Footer;
